<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div class="container calendar_container p-3">
    <div class="d-flex" v-if="has_user_subscription">
      <div class="multiselect-calendar">
        <multiselect
          class="pb-3"
          v-model="selected_calendars"
          :options="calendars"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :placeholder="t('components.calendars.main.multiselect.placeholder')"
          label="name"
          track-by="name"
          selectedLabel=''
          :deselectLabel="t('components.calendars.main.multiselect.deselectLabel')"
          :selectLabel="t('components.calendars.main.multiselect.selectLabel')"
          :preselect-first="true">
          <template slot="selection" slot-scope="{ isOpen }">
            <span class="multiselect__single" v-if="selected_calendars.length &amp;&amp; !isOpen">
              {{ t('components.calendars.main.multiselect.single_text', { selected_length: selected_calendars.length }) }}
            </span>
          </template>
        </multiselect>
      </div>
      <calendars-config-modal-vue class="ml-auto" />
      <loader-vue v-if="calendarsLoading" :visible="true"/>
    </div>

    <div class="calendar-content" id="calendar_container">
      <div class="calendar-content__overlay" id="calendar_overlay" v-if="!has_user_subscription">
        <p v-html="t('components.calendars.main.not_personalized_message')" />
        <span class="d-flex align-items-center justify-content-center" @click="showLoginForm"> {{ t('components.calendars.main.personalized_button') }} </span>
      </div>
      <FullCalendar-vue
        :options="calendar_options"
      />
    </div>

    <calendars-event-modal-vue
      :is_visible.sync="add_event_modal_visible"
      :input_date="selected_date"
    />
    <calendars-event-modal-vue
      :is_visible.sync="edit_event_modal_visible"
      :event="selected_event"
    />
    <user-subscription-modal-login-vue ref="user_subscription_login_modal" @login:success="load_user_calendars"/>
  </div>
</template>

<script>
import mixins from "common/mixins";
import Multiselect from 'vue-multiselect'
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from '@fullcalendar/list';
import interactionPlugin from "@fullcalendar/interaction";
import iCalendarPlugin from "@fullcalendar/icalendar";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "calendars-main-vue",
  components: {
    Multiselect,
    "FullCalendar-vue": FullCalendar,
    "user-subscription-modal-login-vue": () =>import( /* webpackChunkName: "[request]" */ "components/user_subscription/ModalLogin"),
    "calendars-config-modal-vue": () => import( /* webpackChunkName: "[request]" */ "components/calendars/ConfigModal"),
    "calendars-event-modal-vue": () => import( /* webpackChunkName: "[request]" */ "components/calendars/EventModal"),
    "loader-vue": () => import(/* webpackChunkName: "[request]" */ "components/Loader")
  },
  mixins: [mixins.requests, mixins.translate],
  data() {
    return {
      add_event_modal_visible: false,
      selected_date: "",
      edit_event_modal_visible: false,
      selected_event: null,
      selected_calendars: []
    };
  },
  computed: {
    calendar_options() {
      return {
        plugins: [dayGridPlugin, interactionPlugin, iCalendarPlugin, listPlugin],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        eventSources: this.event_sources(this.selected_calendars),
        eventClick: this.event_clicked,
        locale: 'es',
        views: {
          dayGridMonth: { buttonText: I18n.t('components.calendars.main.button_calendar') },
          listWeek: { buttonText: I18n.t('components.calendars.main.button_list') },
        },
        buttonText: { today: I18n.t('components.calendars.main.today') },
        titleFormat: { year: 'numeric', month: 'short'},
        noEventsContent: I18n.t('components.calendars.main.no_events'),
        headerToolbar: {
          left: "today prev,next",
          center: "title",
          right: "dayGridMonth,listWeek",
        },
        firstDay: 1 // 0-Sunday, 1-Monday, 2-Tuesday, etc
      };
    },
    ...mapState("calendars", ["calendars", "errors"]),
    ...mapState("calendars", {calendarsLoading:"loading"}),
    ...mapGetters('calendars', ['calendars_length', 'event_sources']),
    ...mapGetters(["has_user_subscription"])
  },
  methods: {
    handleDateClick: function (arg) {
      this.add_event_modal_visible = true;
      this.selected_date = arg.dateStr;
    },
    event_clicked(info) {
      var calendar = this.calendars.find((c) => {
        return c.id == info.event.extendedProps.calendar_id;
      });
      if (calendar) {
        this.selected_event = info.event;
        this.edit_event_modal_visible = true;
      } else {
        alert(I18n.t('components.calendars.main.external_calendar_alert'));
      }
    },
    showLoginForm() {
      this.$refs.user_subscription_login_modal.show()
    },
    async load_user_calendars(){
      if (this.has_user_subscription) {
        await this.load_calendars();
        this.selected_calendars = [...this.calendars];
      }
    },
    ...mapActions("calendars", ["load_calendars", "create_calendar"]),
  },
  watch: {
    calendars_length(new_value, old_value) {
      if (new_value > old_value) {
        this.selected_calendars.push(this.calendars[new_value-1])
      } else {
        this.selected_calendars = this.calendars.filter(cal => this.selected_calendars.includes(cal));
      }
    }
  },
  mounted() {
    this.load_user_calendars();
  },
};
</script>